<template>
  <div
    v-if="hasAnyValue"
    class="calc-end-user-cell"
  >
    <template v-if="hasRanges">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <span
            class="calc-end-user-cell__value calc-end-user-cell__value--with-ranges"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small>mdi-layers-outline</v-icon>
            {{ formatAmount(displayRate, 4) }}
          </span>
        </template>
        <div class="calc-end-user-cell__ranges">
          <div
            v-for="(range, index) in sortedRanges"
            :key="`range-${index}`"
            class="calc-end-user-cell__range-row"
          >
            <span class="calc-end-user-cell__range-min">
              ≥ {{ formatAmount(range.minAmount, 2) }}
            </span>
            <span class="calc-end-user-cell__range-rate">
              {{ formatAmount(range.rate, 4) }}
            </span>
          </div>
        </div>
      </v-tooltip>
    </template>
    <span
      v-else
      class="calc-end-user-cell__value"
    >
      {{ formatAmount(displayRate, 4) }}
    </span>

    <v-tooltip
      v-if="calcDiscountedUserRate"
      top
    >
      <template #activator="{ on, attrs }">
        <span
          class="calc-end-user-cell__discount-activator"
          v-bind="attrs"
          v-on="on"
        >
          /
          <v-chip color="amber lighten-1">
            {{ calcDiscountedUserRate | formatMoney(4) }}
          </v-chip>
        </span>
      </template>
      <span>Calc Discounted User Rate</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CalcEndUserCell",
  props: {
    calcEndUserRate: {
      type: [String, Number],
      default: ''
    },
    calcDiscountedUserRate: {
      type: [String, Number],
      default: ''
    },
    rateRanges: {
      type: Array,
      default: () => []
    },
    preferScalar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasRanges() {
      return Array.isArray(this.rateRanges) && this.rateRanges.length > 0;
    },
    sortedRanges() {
      if (!this.hasRanges) {
        return [];
      }
      return [...this.rateRanges].sort((a, b) => {
        const aMin = Number(a?.minAmount ?? 0);
        const bMin = Number(b?.minAmount ?? 0);
        return aMin - bMin;
      });
    },
    displayRate() {
      if (!this.preferScalar && this.hasRanges && this.sortedRanges.length) {
        const lastRange = this.sortedRanges[this.sortedRanges.length - 1];
        return lastRange?.rate ?? this.calcEndUserRate;
      }
      return this.calcEndUserRate;
    },
    hasAnyValue() {
      return (
        this.hasRanges ||
        this.calcEndUserRate !== null && this.calcEndUserRate !== undefined && this.calcEndUserRate !== '' ||
        this.calcDiscountedUserRate !== null && this.calcDiscountedUserRate !== undefined && this.calcDiscountedUserRate !== ''
      );
    }
  },

  methods: {
    formatAmount(value, digits = 2) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      const formatter = this.$options?.filters?.formatMoney;
      return formatter ? formatter(value, digits) : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-end-user-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &__value {
    display: inline-flex;
    align-items: center;
  }

  &__value--with-ranges {
    color: #1976d2;
    font-weight: 600;
    cursor: pointer;

    .v-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  &__discount-activator {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  &__ranges {
    min-width: 200px;
    display: flex;
    flex-direction: column;
  }

  &__range-row {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    padding: 2px 0;
  }

  &__range-min {
    font-weight: 600;
    padding-right: 8px;
  }
}
</style>
